import { EAirepType, IFlightLevel } from "@naviair-utm/node-shared-interfaces";
import { getMatch } from "../CommonParsers";
import { flightLevelRegex, icaoRegex } from "./AirepRegExp";

/**
 * Get the type of airep. There are a normal airep and a special airep for urgent attention
 */
export const airepTypeParser = (input: string): EAirepType | null => {
  const inputUpperCase = input.toUpperCase();
  if (inputUpperCase.search("AIREP SPECIAL") !== -1) {
    return EAirepType.AIREP_SPECIAL;
  } else if (inputUpperCase.search("AIREP") !== -1) {
    return EAirepType.AIREP;
  } else {
    return null;
  }
};

export const airepIcaoParser = (input: string): string | null => {
  const icaoMatch = input.match(icaoRegex);
  const icao = getMatch(icaoMatch);
  return icao === "" ? null : icao;
};

/**
 * Get the flight level which might be a single number or an interval with two numbers
 */
export const flightLevelParser = (input: string): IFlightLevel | null => {
  const flightLevel = input.match(flightLevelRegex);
  let returnObj = {} as IFlightLevel;

  // If index 2 is set, then there are two numbers. If not, then only one flight level
  if (getMatch(flightLevel, 2)) {
    const fl1 = parseInt(getMatch(flightLevel, 1));
    const fl2 = parseInt(getMatch(flightLevel, 2));

    if (!isNaN(fl1) && !isNaN(fl2)) {
      if (fl1 <= fl2) {
        returnObj.levelMin = fl1;
        returnObj.levelMax = fl2;
      } else {
        returnObj.levelMin = fl2;
        returnObj.levelMax = fl1;
      }
    } else {
      return null;
    }
  } else {
    const fl = parseInt(getMatch(flightLevel, 1));

    if (!isNaN(fl)) {
      returnObj.level = fl;
    } else {
      return null;
    }
  }

  return returnObj;
};

/**
 *  Get the last line which is the body of the airep
 */
export const bodyParser = (input: string): string => {
  const lines = input.split("\n");
  return lines[lines.length - 1];
};
